// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var imageGalleryIcon = "blexia-module--image-gallery-icon--1uXzS";
export var imageGallerySvg = "blexia-module--image-gallery-svg--12Ysk";
export var imageGalleryUsingMouse = "blexia-module--image-gallery-using-mouse--2L9MN";
export var imageGalleryFullscreenButton = "blexia-module--image-gallery-fullscreen-button--2xWps";
export var imageGalleryPlayButton = "blexia-module--image-gallery-play-button--1p4qx";
export var imageGalleryLeftNav = "blexia-module--image-gallery-left-nav--nMBDp";
export var imageGalleryRightNav = "blexia-module--image-gallery-right-nav--3ZljD";
export var imageGallery = "blexia-module--image-gallery--yaUAG";
export var fullscreenModal = "blexia-module--fullscreen-modal--3ZN84";
export var imageGalleryContent = "blexia-module--image-gallery-content--1VkPF";
export var fullscreen = "blexia-module--fullscreen--2gRsF";
export var imageGallerySlide = "blexia-module--image-gallery-slide--FNLQ3";
export var imageGalleryImage = "blexia-module--image-gallery-image--1qwIj";
export var left = "blexia-module--left--25nLG";
export var right = "blexia-module--right--2D-tv";
export var imageGallerySlideWrapper = "blexia-module--image-gallery-slide-wrapper--KxoWF";
export var imageGalleryRtl = "blexia-module--image-gallery-rtl--3Gybu";
export var imageGallerySlides = "blexia-module--image-gallery-slides--Xn7WO";
export var center = "blexia-module--center--2-ibz";
export var imageGalleryDescription = "blexia-module--image-gallery-description--1R7GK";
export var imageGalleryBullets = "blexia-module--image-gallery-bullets--u4lgf";
export var imageGalleryBulletsContainer = "blexia-module--image-gallery-bullets-container--p6TU7";
export var imageGalleryBullet = "blexia-module--image-gallery-bullet--qB6l_";
export var active = "blexia-module--active--1po3k";
export var imageGalleryThumbnailsWrapper = "blexia-module--image-gallery-thumbnails-wrapper--1_K_2";
export var thumbnailsSwipeHorizontal = "blexia-module--thumbnails-swipe-horizontal--322jp";
export var thumbnailsSwipeVertical = "blexia-module--thumbnails-swipe-vertical--2bbu9";
export var thumbnailsWrapperRtl = "blexia-module--thumbnails-wrapper-rtl--14vFH";
export var imageGalleryThumbnails = "blexia-module--image-gallery-thumbnails--2uQep";
export var imageGalleryThumbnail = "blexia-module--image-gallery-thumbnail--2kz4r";
export var imageGalleryThumbnailsContainer = "blexia-module--image-gallery-thumbnails-container--1u9-3";
export var imageGalleryThumbnailInner = "blexia-module--image-gallery-thumbnail-inner--jJfMu";
export var imageGalleryThumbnailImage = "blexia-module--image-gallery-thumbnail-image--1HFLf";
export var imageGalleryThumbnailLabel = "blexia-module--image-gallery-thumbnail-label--3hB71";
export var imageGalleryIndex = "blexia-module--image-gallery-index--HiiLM";
export var content = "blexia-module--content--3WobW";
export var contentContainer = "blexia-module--contentContainer--pfmOA";
export var line = "blexia-module--line--3eW2_";
export var heroSection = "blexia-module--heroSection--j852L";
export var overlay = "blexia-module--overlay--2dva_";
export var backgroundImage = "blexia-module--backgroundImage--2q5Rf";
export var mask = "blexia-module--mask--1HyNQ";
export var logo = "blexia-module--logo--29rsO";
export var introSection = "blexia-module--introSection--3-l9n";
export var featuredText = "blexia-module--featuredText--22kw1";
export var backgroundBox = "blexia-module--backgroundBox--2Lx-1";
export var ourProductsSection = "blexia-module--ourProductsSection--18oXS";
export var productsImageContainer = "blexia-module--productsImageContainer--3QzhB";
export var productsMask = "blexia-module--productsMask--2NZI8";
export var productImage = "blexia-module--productImage--1puZI";
export var bodyText = "blexia-module--bodyText--2y_a8";
export var productsListSection = "blexia-module--productsListSection--4idCa";
export var videoGallery = "blexia-module--videoGallery--3lC-k";
export var watermark = "blexia-module--watermark--2ZSqm";
export var blexiaProductsContainer = "blexia-module--blexiaProductsContainer--113a1";
export var cardLinkWrapper = "blexia-module--cardLinkWrapper--1kwlM";
export var mockEvent = "blexia-module--mockEvent--3HZ0_";